<template>
  <template v-if="$route.meta.fullscreen">
    <router-view />
  </template>
  <master-layout v-else>
    <router-view />
  </master-layout>
</template>

<script>
import MasterLayout from '@/layouts/Master'

export default {
  name: 'App',
  components: {
    MasterLayout
  }
}
</script>
